import { enterpriseApiSlice } from "./index";
import { API_STATES } from "../Enums/apiStates";
import { UserInvitationByIdentifier, UserInvitationsList } from "../Model/userObjects";

export const userInvitationsApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchUserInvitationByIdentifier: builder.query({
      query: (identifier) => ({
        url: `/user-invitations/by-identifier/${identifier}`,
        method: "GET",
      }),
      transformResponse: (response, _meta, identifier) =>
        new UserInvitationByIdentifier(identifier, response, API_STATES.SUCCESS),
      keepUnusedDataFor: 0,
    }),
    acceptUserInvitation: builder.mutation({
      query: ({ identifier, password }) => ({
        url: `/user-invitations/by-identifier/${identifier}/accept`,
        method: "POST",
        body: { password },
      }),
    }),
    fetchPendingUserInvitations: builder.query({
      query: () => ({
        url: "/user-invitations/pending",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["UserInvitations"],
      transformResponse: (response) => new UserInvitationsList(response),
    }),
    deleteUserInvitation: builder.mutation({
      query: (id) => ({
        url: `/user-invitations/${id}`,
        method: "DELETE",
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["UserInvitations"],
    }),
    resendUserInvitation: builder.mutation({
      query: (id) => ({
        url: `/user-invitations/${id}/resend`,
        method: "POST",
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["UserInvitations"],
    }),
    sendMultipleUserInvitations: builder.mutation({
      query: (data) => ({
        url: "/user-invitations/multiple",
        method: "POST",
        body: data,
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["UserInvitations"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchUserInvitationByIdentifierQuery,
  useAcceptUserInvitationMutation,
  useFetchPendingUserInvitationsQuery,
  useDeleteUserInvitationMutation,
  useResendUserInvitationMutation,
  useSendMultipleUserInvitationsMutation,
} = userInvitationsApi;
